import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useTextEntryContext} from '../../../context/TextEntryContextProvider';
import AppMenu from '../../common/AppMenu';
import GTranslateIcon from '@mui/icons-material/GTranslate';
import {IMAGES} from '../../../constants/assetLists';
import {handleUpdateLanguageService} from '../../../services/users';
import {useMutation} from '@tanstack/react-query';

const LANGUAGES = [
  {value: 'en', title: 'English', icon: IMAGES.englishFlag},
  {value: 'heb', title: 'he', icon: IMAGES.israelFlag},
];

function LanguageChange() {
  const {i18n} = useTranslation();
  const {lang, setLang} = useTextEntryContext();

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const {mutate: handleUpdateLanguage} = useMutation({
    mutationFn: handleUpdateLanguageService,
    onSuccess: data => {
      localStorage.setItem('userToken', data?.data?.token);
    },
  });

  const changeLanguage = (lng: string) => {
    if (lang != lng) {
      handleUpdateLanguage({lang: lng});
      localStorage.setItem('currentLang', lng);
      i18n.changeLanguage(lng);
      document.documentElement.dir = lng === 'heb' ? 'rtl' : 'ltr';
      setLang(lng);
    }
  };

  return (
    <AppMenu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onOpen={handleMenuOpen}
      onClose={handleMenuClose}
      items={LANGUAGES}
      selectedItem={lang}
      onItemClick={changeLanguage}
      menuIcon={<GTranslateIcon sx={{color: '#BABCBE', fontSize: 24}} />}
    />
  );
}

export default LanguageChange;
